// src/styles/components/MuiCard.js
const MuiCard = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.background.paper,
      overflow: 'hidden',
      position: 'relative',
      '&:hover': {
        '& .card-content': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    }),
  },
};

export default MuiCard;